export default __webpack_public_path__ + "static/14-ab44908683eb866b960cc65b8e86c76c.webp";